import { render, staticRenderFns } from "./SkinxsCampaignsTab.vue?vue&type=template&id=34ee64a4&scoped=true"
import script from "./SkinxsCampaignsTab.vue?vue&type=script&lang=js"
export * from "./SkinxsCampaignsTab.vue?vue&type=script&lang=js"
import style0 from "./SkinxsCampaignsTab.vue?vue&type=style&index=0&id=34ee64a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ee64a4",
  null
  
)

export default component.exports